var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "identity-approved"
  }, [_c('substrate-mount', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('send.new.request.for.refresh.information'))
    }
  }), _c('div', [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "size": "small"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('reset');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('notify.about.data.change')) + " ")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }